import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token, css }) => {
  return {
    chat: css`
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 16px;
      transition: all 0.3s cubic-bezier(0.34, 0.69, 0.1, 1);
      position: relative;
    `,
    messages: css`
      flex: 1;
      margin-bottom: 16px;
      padding-bottom: 40px;
      overflow-y: auto;
    `,
    container: css`
      display: flex;
      flex-direction: column;
      height: 100vh;
      width: 100%;
      position: relative;
      overflow: hidden;
    `,
    messagesContainer: css`
      flex: 1;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: 16px;
      scroll-behavior: smooth;
      padding: 16px 0;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: ${token.colorTextTertiary};
        border-radius: 3px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: ${token.colorTextSecondary};
      }
    `,
    sender: css`
      box-shadow: ${token.boxShadow};
      margin-bottom: 50px;
      position: relative;
      border-radius: 12px;
      width: 100%;

      .ant-sender-textarea {
        transition: height 0.3s ease, max-height 0.3s ease;
        min-height: 56px;
      }
      .ant-sender-content {
        background: ${token.colorBgElevated};
      }
    `,
    actionButtons: css`
      display: flex;
      gap: 12px;
      height: '40px',
      alignItems: 'center',
      justifyContent: 'center',
    `,

    landingContainer: css`
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
    `,
    landingHeader: css`
      margin: 10px 18px;
      background: transparent;
      @media (max-width: 1000px) {
        margin: 8px auto;
      }
    `,
    landingContent: css`
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `,
    placeholder: css``,
    article: css`
      width: 1000px;
      margin: 0 auto;
      @media (max-width: 1100px) {
        width: 90vw;
      }
    `,
  }
})
